import { OnboardingIndexRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/onboarding/')({
  component: OnboardingIndexRedirect,
});
